export default __webpack_public_path__ + "static/media/NavigationMenuCross.3ddf4e78.svg";